class InlineLink {
    static get isInline() {
        return true;
    }

    static get title() {
        return 'Link';
    }

    static get sanitize() {
        return {
            a: {
                href: true,
                target: true,
                rel: true,
            },
        };
    }

    constructor() {
        this.button = null;
        this.range = null;
        this.popover = null;
        this.input = null;
        this.handleOutsideClick = this.handleOutsideClick.bind(this);
    }

    handleOutsideClick(event) {
        if (
            this.popover?.contains(event.target) ||
            this.button?.contains(event.target)
        ) {
            return;
        }

        this.closeInput();
    }

    render() {
        this.button = document.createElement('button');

        this.button.type = 'button';
        this.button.innerHTML = '🔗';
        this.button.classList.add('ce-inline-tool');

        return this.button;
    }

    surround(range) {
        if (!range || range.collapsed) {
            return;
        }

        const existingLink = InlineLink.findParentLink(
            range.commonAncestorContainer,
        );

        if (existingLink) {
            InlineLink.unwrap(existingLink);
            return;
        }

        this.range = range.cloneRange();
        this.openInput();
    }

    openInput() {
        this.closeInput(false);

        const toolbar = document.querySelector('.ce-inline-toolbar');
        const toolbarRect = toolbar?.getBoundingClientRect();

        this.popover = document.createElement('div');
        this.popover.className = 'ce-inline-link-popover';

        this.popover.style.position = 'fixed';
        this.popover.style.zIndex = '9999';
        this.popover.style.left = `${toolbarRect?.left ?? 20}px`;
        this.popover.style.top = `${(toolbarRect?.bottom ?? 20) + 6}px`;

        this.input = document.createElement('input');
        this.input.type = 'text';
        this.input.placeholder = 'Paste or type a link...';
        this.input.className = 'ce-inline-link-input';

        this.input.addEventListener('keydown', (event) => {
            if (event.key === 'Enter') {
                event.preventDefault();
                this.applyLink();
            }

            if (event.key === 'Escape') {
                event.preventDefault();
                this.closeInput();
            }
        });

        this.input.addEventListener('paste', (event) => {
            const pasted = event.clipboardData?.getData('text')?.trim() ?? '';

            if (/^[a-z][a-z0-9+.-]*:\/\//i.test(pasted)) {
                event.preventDefault();
                this.input.value = pasted;
            }
        });

        this.input.addEventListener('input', () => {
            this.input?.classList.remove('ce-inline-link-input--invalid');
        });

        this.popover.appendChild(this.input);
        document.body.appendChild(this.popover);

        this.input.value = 'https://';
        this.input.focus();
        const end = this.input.value.length;
        this.input.setSelectionRange(end, end);

        setTimeout(() => {
            document.addEventListener('mousedown', this.handleOutsideClick);
        }, 0);
    }

    static normaliseHttpsUrl(value) {
        const deduped = value.trim().replace(/^https:\/\/(?=https?:\/\/)/i, '');

        const hasScheme = /^[a-z][a-z0-9+.-]*:/i.test(deduped);
        const candidate = hasScheme ? deduped : `https://${deduped}`;

        let url;
        try {
            url = new URL(candidate);
        } catch {
            return null;
        }

        if (url.protocol !== 'https:') {
            return null;
        }

        if (!url.hostname) {
            return null;
        }

        return url.href;
    }

    applyLink() {
        const rawHref = this.input?.value.trim();

        if (!rawHref || !this.range) {
            this.closeInput();
            return;
        }

        const href = InlineLink.normaliseHttpsUrl(rawHref);

        if (!href) {
            this.showInvalid();
            return;
        }

        const link = document.createElement('a');
        link.href = href;
        link.target = '_blank';
        link.rel = 'noopener noreferrer nofollow';

        const content = this.range.extractContents();
        link.appendChild(content);
        this.range.insertNode(link);

        this.closeInput();
    }

    showInvalid() {
        if (!this.input) {
            return;
        }

        this.input.classList.add('ce-inline-link-input--invalid');
        this.input.focus();

        console.log(
            'showInvalid: class added?',
            this.input.classList.contains('ce-inline-link-input--invalid'),
        );

        setTimeout(() => {
            console.log(
                'showInvalid +100ms: class still there?',
                this.input?.classList.contains('ce-inline-link-input--invalid'),
            );
        }, 100);
    }

    closeInput(clearRange = true) {
        document.removeEventListener('mousedown', this.handleOutsideClick);

        this.popover?.remove();

        this.popover = null;
        this.input = null;

        if (clearRange) {
            this.range = null;
        }
    }

    checkState(selection) {
        const anchor = InlineLink.findParentLink(selection.anchorNode);

        if (anchor) {
            this.button?.classList.add('ce-inline-tool--active');
            return true;
        }

        this.button?.classList.remove('ce-inline-tool--active');
        return false;
    }

    static findParentLink(node) {
        let currentNode = node;

        while (currentNode) {
            if (
                currentNode.nodeType === Node.ELEMENT_NODE &&
                currentNode.tagName === 'A'
            ) {
                return currentNode;
            }

            currentNode = currentNode.parentNode;
        }

        return null;
    }

    static unwrap(link) {
        const parent = link.parentNode;

        while (link.firstChild) {
            parent.insertBefore(link.firstChild, link);
        }

        parent.removeChild(link);
    }
}

export default InlineLink;
